"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProvider = exports.setCapabilities = exports.setAppointment = exports.sendParentExit = exports.sendParentDone = void 0;
const xstate_1 = require("xstate");
const Events_1 = require("../../../lib/constants/Events");
const setAppointment = '@action/SET_APPOINTMENT';
exports.setAppointment = setAppointment;
const setCapabilities = '@action/SET_CAPABILITIES';
exports.setCapabilities = setCapabilities;
const setProvider = '@action/SET_PROVIDER';
exports.setProvider = setProvider;
const sendParentDone = '@action/SEND_PARENT_DONE';
exports.sendParentDone = sendParentDone;
const sendParentExit = '@action/SEND_PARENT_EXIT';
exports.sendParentExit = sendParentExit;
const actions = {
    [setAppointment]: (0, xstate_1.assign)({
        appointment: (_context, event) => {
            return event.data.appointment;
        }
    }),
    [setProvider]: (0, xstate_1.assign)({
        provider: (_context, event) => {
            return event.data;
        }
    }),
    [setCapabilities]: (0, xstate_1.assign)({
        capabilities: (_context, event) => {
            var _a, _b;
            const { capabilities } = event.data;
            return {
                isCancelEnabled: (_a = capabilities === null || capabilities === void 0 ? void 0 : capabilities.cancel) === null || _a === void 0 ? void 0 : _a.enabled,
                isRescheduleEnabled: (_b = capabilities === null || capabilities === void 0 ? void 0 : capabilities.reschedule) === null || _b === void 0 ? void 0 : _b.enabled
            };
        }
    }),
    // Send to parent machine the appointment, provider and capabilities
    [sendParentDone]: (0, xstate_1.sendParent)((ctx) => {
        return {
            type: Events_1.LOADING_DONE,
            context: {
                appointment: ctx.appointment,
                provider: ctx.provider,
                capabilities: ctx.capabilities
            }
        };
    }),
    // Send to parent machine what apis failed to load
    [sendParentExit]: (0, xstate_1.sendParent)((ctx) => ({
        type: Events_1.LOADING_ERROR,
        context: {
            appointment: ctx.appointment ? false : true,
            provider: ctx.provider ? false : true
        }
    }))
};
exports.default = actions;
//# sourceMappingURL=actions.loadingMachine.js.map